import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { t } from 'i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UserModal from '../../Modals/UserModal';



const PrimaryAccordionUser = ({ elements, r, text = '', hasContent = true }) => {
    const [accordionOpen, setAccordionOpen] = React.useState(false);
    const [expanded, setExpanded] = React.useState('');


    if (elements.length == 0) {
        return ''
    }
    const handleChange = (panel) => {
        if (panel == expanded) {
            setExpanded('')
        } else {
            setExpanded(panel);
        }
    };
    return (
        <>
            {elements?.map((e, i) => (
                <div key={e.id}>
                    <div className="accordionContainer ">
                        <div className='Vartotojai  '>
                            <Accordion
                                expanded={expanded === 'panel' + e.id}
                                onChange={() => { handleChange('panel' + e.id) }}
                                // expanded={accordionOpen}
                                style={{ boxShadow: "none" }}>
                                <AccordionSummary
                                    id={e.id}
                                    expandIcon={
                                        <ExpandMoreIcon style={{ cursor: 'pointer' }}
                                            onClick={() => handleChange('panel' + e.id)}
                                        />
                                    }
                                    sx={{ cursor: 'unset !important' }}
                                    className={' Accordion'}
                                >
                                    <div className={'userAccSummary accordionSummary'}>
                                        <div className='userInfoAcc'>
                                            {t(text)}

                                            <div className="row alignCenter margin">
                                                <p className="formosPavadinimas margin">
                                                    {e.imonesPavadinimas}
                                                </p>
                                                <p className={e.confirmed == true ?
                                                new Date(e.validTo).getFullYear() >= new Date().getFullYear() ? "statusas margin green" : "statusas margin yellow"
                                                : "statusas margin red"}>
                                                {e.confirmed == true ?
                                                new Date(e.validTo).getFullYear() >= new Date().getFullYear() ? 
                                                    (new Date(e.validTo).getFullYear() === 3000 ? 
                                                        `${t('patvirtinta')} (${t('neribotai')})` : 
                                                        `${t('patvirtinta')} (${t('galioja_iki')} ${new Date(e.validTo).toLocaleDateString()})`) : 
                                                    t('nebegalioja') : 
                                                        t('negalioja')
                                    }
                                </p>
                                            </div>
                                        </div>
                                        {/* <div className={props.classNameElement}>
                                            {props.element}
                                        </div> */}
                                    </div>
                                </AccordionSummary>
                                {hasContent ?

                                    <AccordionDetails className='AccordionDetalilsCont'>
                                        <UserModal
                                            info={e}
                                            r={() => { r(); handleChange('') }}
                                        />
                                    </AccordionDetails>
                                    : ""}
                            </Accordion>
                        </div >
                    </div>
                </div>))}
        </>
    )
}
export default PrimaryAccordionUser
